// extracted by mini-css-extract-plugin
export default {"arrow":"PortfolioArrow_arrow__ZpZAK","bounce":"PortfolioArrow_bounce__v-+ly"};